import { render, staticRenderFns } from "./invite-user.vue?vue&type=template&id=06f9c2af&scoped=true"
import script from "./invite-user.vue?vue&type=script&lang=js"
export * from "./invite-user.vue?vue&type=script&lang=js"
import style0 from "./invite-user.vue?vue&type=style&index=0&id=06f9c2af&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f9c2af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f9c2af')) {
      api.createRecord('06f9c2af', component.options)
    } else {
      api.reload('06f9c2af', component.options)
    }
    module.hot.accept("./invite-user.vue?vue&type=template&id=06f9c2af&scoped=true", function () {
      api.rerender('06f9c2af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/invite-user.vue"
export default component.exports